module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAPCAYAAADUFP50AAABCklEQVQ4T5XRsUrDYBSG4fdLoZIobi5OInoFKi6CgxegNBEnCy69gE4FFwUXB1cXoZMgljQXIHoHLoKbiAiC4J5YEXPkL0UUIU3OeHif5RxRMFnMJbBsYm0y5PV3qjHwETEvOPBDDkvB9IJZ1XkBhNELInZKwSzhBKM9jI3zIGJ3LHzvsW4eN4jaKD4OQjqFMItZNbiSmP4Jc8Jgm+QPzGIGiInhMidENBGbRUfDeFIW84Gou1CwZ8ZWCThw8A0xUwXKuHfwAbFQBZrRdfAWsVQJipaD14iNKtD7YtHBPqJRGhrPQcSc0j5dd82yUMaZH9FSmnAkY38Em0DNjFOE/++XxmfusTLV4O4bse9lqx1g2LAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/praise.png
// module id = wKjj
// module chunks = 0